<template>
  <div class="claim-step">
    <div class="identity-preview">
      <img v-if="portraitUrl" :src="portraitUrl" class="preview-portrait" />
      <div class="preview-name">{{ chosenName }}</div>
    </div>

    <div class="terms-section">
      <label class="terms-label">
        <input type="checkbox" v-model="agreedToTerms" class="terms-checkbox" />
        <span>I agree to the <a href="/reader-terms" target="_blank" class="terms-link" @click.stop>Reader Terms</a></span>
      </label>
    </div>

    <div v-if="error" class="error-msg">{{ error }}</div>

    <button
      class="primary-btn"
      :disabled="!agreedToTerms || claiming"
      @click="claim"
    >
      {{ claiming ? 'One moment...' : 'Bring ' + chosenName + ' to Life \u2192' }}
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { static_store } from '@/store'

const props = defineProps({
  chosenName: String,
  portraitUrl: String,
  provisioningId: Number,
})
const emit = defineEmits(['claimed'])

const agreedToTerms = ref(false)
const claiming = ref(false)
const error = ref('')

async function claim() {
  if (!agreedToTerms.value) return
  if (!props.provisioningId) {
    error.value = 'Session expired. Please go back and restart the process.'
    return
  }
  claiming.value = true
  error.value = ''
  try {
    const token = localStorage.getItem('authToken')
    const resp = await axios.post(
      `${static_store.apiUrl}/reader/become-mystic/claim/${props.provisioningId}/`,
      {},
      { headers: { Authorization: `Token ${token}` } }
    )
    emit('claimed', {
      subdomain: resp.data.reader_subdomain,
      name: resp.data.reader_name,
      readerId: resp.data.reader_id,
    })
  } catch (e) {
    error.value = e.response?.data?.error || e.message
  } finally {
    claiming.value = false
  }
}
</script>

<style scoped>
.claim-step {
  color: #E8D8FF; display: flex; flex-direction: column;
  align-items: center; gap: 20px; padding: 16px 0;
}
.identity-preview { display: flex; flex-direction: column; align-items: center; gap: 10px; }
.preview-portrait {
  width: 80px; height: 80px; border-radius: 10px; object-fit: cover;
  border: 1px solid rgba(125,232,204,0.3);
}
.preview-name { font-size: 20px; font-weight: 500; color: #7DE8CC; }
.terms-section { width: 100%; }
.terms-label {
  display: flex; align-items: center; gap: 10px;
  font-size: 13px; color: rgba(255,255,255,0.6); cursor: pointer;
}
.terms-checkbox {
  accent-color: #7DE8CC; width: 16px; height: 16px; cursor: pointer;
}
.terms-link { color: #7DE8CC; text-decoration: underline; }
.error-msg { font-size: 13px; color: rgba(255,120,120,0.85); }
.primary-btn {
  width: 100%; padding: 15px;
  background: rgba(50,192,158,0.12); border: 1px solid rgba(50,192,158,0.4);
  border-radius: 12px; color: #7DE8CC; font-size: 14px; font-weight: 500;
  cursor: pointer; font-family: inherit; transition: all 0.2s;
}
.primary-btn:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
